import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import { router } from 'expo-router'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'

export default function OrdersSection() {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { t } = useTranslation(['ui', 'customer'])
  const text = 'customer:home.sections.orders'

  const onPress = () => router.navigate('/customer/order/history')

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          classNameDesc={Platform.select({ default: 'pr-8', web: 'pr-12' })}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/box.png'),
            imageWrapperStyle: Platform.select({
              default: { width: '66%', height: '66%' },
              web: { width: '75%', height: '75%' },
            }),
            imageStyle: {
              transform: Platform.select({
                default: [{ translateX: -10 }, { translateY: 0 }],
                web: [{ translateX: -25 }, { translateY: 0 }],
              }),
            },
            blur: Platform.select({ default: 100, web: 25 }),
            blurStyle: Platform.select({
              default: {
                opacity: 0.5,
                transform: [
                  { translateX: -55 },
                  { translateY: 120 },
                  { scale: 0.55 },
                ],
              },
              web: {
                opacity: 0.5,
                transform: [
                  { translateX: -25 },
                  { translateY: 150 },
                  { scale: 0.8 },
                ],
              },
            }),
          }}
        />
      </Pressable>
    </>
  )
}
